import type { IUiLinkMap } from '@experiences/interfaces';

export const EventsHubConnectionsString: IUiLinkMap = new Map([
    // eslint-disable-next-line max-len
    [ 'en', 'https://learn.microsoft.com/en-us/azure/event-hubs/event-hubs-get-connection-string#connection-string-for-a-specific-event-hub-in-a-namespace' ],
]);

